<script>
export default {
  props: ["icon", "label"],
  data: function () {
    return {};
  },
  methods: {},
};
</script>

<template>
  <div class="f-drop-down-header">
    <f-icon :icon="icon" class="f-drop-down-header-icon"></f-icon>{{ $vt(label) }}
  </div>
</template>

<style lang="scss" scoped>
.f-drop-down-header {
  font-size: 14px;
  font-family: Lato;
  font-weight: 700;

  display: flex;
  flex-direction: row;
  gap: 7px;
  padding: 16px 11px 26px 11px;

  .f-drop-down-header-icon {
    color: rgba(92, 186, 182, 1);
    font-size: 18px;
  }
}

.dark-mode {
  .f-drop-down-header {
    color: var(--white-a75);
	font-size: 16px;

    .f-drop-down-header-icon {
      color: var(--primary);
    }
  }
}
</style>